module.exports = __webpack_public_path__ + "static/media/3794.44888053.jpg";